import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { MenuProvider } from './contexts/MenuContext';

import { GlobalStyles } from './components/GlobalStyles';
import Router from './components/Router';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5분
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <GlobalStyles />
        <MenuProvider>
          <Router />
        </MenuProvider>
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;
